import { env } from '../env';
import { NERDWALLET_TOKEN_SERVICE_PATH } from './constants';
import { type Auth0UrlParameters } from './types';

export { NERDWALLET_TOKEN_SERVICE_PATH };

export class Auth0 {
  private origin: string;

  constructor(origin: string) {
    this.origin = origin;
  }

  public generateAuthLink({ extraParams, ...restParams }: Partial<Auth0UrlParameters>) {
    const loginURL = new URL(NERDWALLET_TOKEN_SERVICE_PATH, this.origin);

    const options = {
      ...restParams,
      ...extraParams,
    };

    Object.entries(options).forEach(([key, value]) => {
      if (value) {
        loginURL.searchParams.append(key, value.toString());
      }
    });

    return loginURL.toString();
  }
}

export const auth0 = new Auth0(
  env.NEXT_PUBLIC_DEPLOYABLE_ENV === 'prod'
    ? 'https://www.nerdwallet.com/'
    : 'https://stage.nerdwallet.biz/',
);
